export const getIsPasskeysConnected = () => {
  if (typeof localStorage === 'undefined') {
    return false;
  }

  // contains stringified array with connected addresses,
  // if no wallet connected returns empty array '[]' (only 2 chars)
  return (localStorage.getItem('requests:0x38_eth_accounts')?.length || 0) > 2;
};
